import { render, staticRenderFns } from "./checkTokenA.vue?vue&type=template&id=34cc18ed&scoped=true&"
import script from "./checkTokenA.vue?vue&type=script&lang=js&"
export * from "./checkTokenA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cc18ed",
  null
  
)

export default component.exports